import { twMerge } from "tailwind-merge";
import Typography, { type TypographyProps } from "@mui/material/Typography";
import { TEXT_COLORS, TEXT_SIZES } from "@typings/components/text";

type TextProps = TypographyProps & {
  children: React.ReactNode;
  className?: string;
  customVariant?: keyof typeof TEXT_COLORS;
  size?: keyof typeof TEXT_SIZES;
};

function Text({
  children,
  className = "",
  size = "base",
  customVariant = "default",
  ...props
}: TextProps) {
  const mergedClasses = twMerge(
    "font-sans",
    TEXT_SIZES[size],
    TEXT_COLORS[customVariant],
    className,
  );

  return (
    <Typography className={mergedClasses} {...props}>
      {children}
    </Typography>
  );
}

export default Text;
